export default "__VITE_ASSET__zFmd9fvH__"